module.exports = __webpack_public_path__ + "img/lungs-animation.78c0f158.gif";